/**
 * Carousel.
 * 
 * @since 1.0.0
 * @param {jQuery} $
 * @returns {undefined}
 */
(function($) { 'use strict';
    $('.carousel-large, .carousel-medium').wartaCarouselCaption();
})(jQuery);